import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'arrayFind',
    standalone: true
})
export class ArrayFindPipe<T> implements PipeTransform {
    transform(items: T[] | null | undefined, filterPredicate: (item: T) => boolean): T | null {
        if (!items) {
            return null;
        }

        return items.find(filterPredicate) ?? null;
    }
}
